import { downloadDocument } from "shared/utils";
import { ACCOUNTANT_REPORT_EXPORT } from "..";
import { apiInstance } from "../config/apiInstance";
import { downloadsTitle } from "shared/utils/data/infoDownloadDocument";

type Ipayload = {
  text: string;
  dateStart?: string;
  dateEnd?: string;
  dateContext?: string;
};

export const getDownloadAccountantReport = async (payload: Ipayload) => {
  const query = `?searchTerm=&dateStart=${payload.dateStart ?? ""}&dateEnd=${
    payload.dateEnd ?? ""
  }&dateContext=${payload.dateContext ?? ""}`;

  const response = await apiInstance.get(
    `${ACCOUNTANT_REPORT_EXPORT}${query}`,
    {
      responseType: "blob",
      timeout: 0,
      headers: {
        "X-Timezone-Id": "America/Bogota",
        "Accept-Language": "es-CO",
      },
    },
  );

  downloadDocument(
    response,
    downloadsTitle.successDocument,
    payload.text,
    "success",
  );
};
